// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__17fX4","paramInput":"JobSimulator_paramInput__D2ZPp","input":"JobSimulator_input__1h-RF"};